/**
 *  Filters constant module file
**/

export const MODULE_NAME = 'filters'

export const ACTIONS = {
}

export const GETTERS = {
  GET_GROUPS: 'getGroups',
  GET_FILTERS: 'getFilters',
  GET_ROUTE_FILTERS: 'getRouteFilters',
  GET_POIS_FILTERS: 'getPoisFilters',
  GET_ADVERTS_FILTERS: 'getAdvertsFilters',
  GET_SHOPS_FILTERS: 'getShopsFilters'
}

export const MUTATIONS = {
  SET_FILTER_VALUE: 'setFilterValue',
  SET_POIS_FILTER_VALUE: 'setPoisFilterValue',
  SET_ADVERTS_FILTER_VALUE: 'setAdvertsFilterValue',
  SET_SHOPS_FILTER_VALUE: 'setShopsFilterValue',
  CLEAR_GROUP: 'clearGroup',
  CLEAR_ALL_FILTERS: 'clearAllFilters',
  UPDATE_FILTER_DEF: 'updateFilterDef',
  SET_ACTIVE_GROUPS: 'setActiveGroups',
  CLEAR_TEXT_FILTERS: 'clearTextFilters'
}
